/**
 * Multiplier values to be used in calculating theme spacings based on `GutterBase * SpacingMultiple[d]`
 */
export const SpacingMultiple = {
    large: 3,
    medium: 2,
    small: 1,
    xl: 4,
    xs: 0.5,
} as const;
